import { useEffect, useState } from 'react';

import { WT_AD_BLOCK_INITIALIZED } from './constants';
import { getAdBlockDetection } from './helpers';
import { getReadyInitialState } from './helpers/get-initial-state';

/**
 * @returns {isReady: boolean, result: boolean|undefined}
 * @description result is undefined if initialization did not happen (aka isReady = false), boolean otherwise.
 */
export const useAdBlockDetection = (): {
  isReady: boolean;
  result: boolean | undefined;
} => {
  const [isReady, setIsReady] = useState(getReadyInitialState());

  useEffect(() => {
    if (isReady) {
      return;
    }

    const handleIsReady = () => {
      setIsReady(true);
    };

    window.addEventListener(WT_AD_BLOCK_INITIALIZED, handleIsReady);

    return () =>
      window.removeEventListener(WT_AD_BLOCK_INITIALIZED, handleIsReady);
  }, [isReady]);

  return {
    isReady,
    result: getAdBlockDetection()?.hasAdBlocker,
  };
};
